// 📁 src/layouts/AdminLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <AdminSidebar />
      <main className="ml-64 p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
